import * as React from 'react'

function SvgNa(props) {
	return (
		<svg viewBox="0 0 90 60" width="1em" height="1em" {...props}>
			<path d="M90 0H0v60z" fill="#003580" />
			<path d="M0 60h90V0z" fill="#009543" />
			<path d="M0 60L90 0" stroke="#fff" strokeWidth={20} />
			<path d="M0 60L90 0" stroke="#d21034" strokeWidth={15} />
			<g fill="#ffce00" transform="translate(18 16.341)">
				<g id="na_svg__b">
					<path id="na_svg__a" d="M0 10l1.553-4.204h-3.106z" />
					<use xlinkHref="#na_svg__a" transform="rotate(90)" />
					<use xlinkHref="#na_svg__a" transform="rotate(180)" />
					<use xlinkHref="#na_svg__a" transform="rotate(270)" />
				</g>
				<use xlinkHref="#na_svg__b" transform="rotate(30)" />
				<use xlinkHref="#na_svg__b" transform="rotate(60)" />
				<circle r={5.5} stroke="#003580" />
			</g>
		</svg>
	)
}

export default SvgNa
